// extracted by mini-css-extract-plugin
export var flowchartContainer = "_m-0";